const category = 'Mission';

const share = {
  category,
  action: 'Share'
};

export default Object.freeze({
  DELETE: Object.freeze({
    OPEN_MODAL: Object.freeze({
      category,
      action: 'Delete',
      label: 'Open modal'
    })
  }),
  SHARE: Object.freeze({
    LINKEDIN: Object.freeze({
      ...share,
      label: 'Linkedin'
    }),
    TWITTER: Object.freeze({
      ...share,
      label: 'Twitter'
    }),
    WHATSAPP: Object.freeze({
      ...share,
      label: 'Whatsapp'
    }),
    FACEBOOK: Object.freeze({
      ...share,
      label: 'Facebook'
    })
  }),
  UNAPPLY: Object.freeze({
    category,
    action: 'Unapply',
    label: 'Click'
  })
});
